import { useEffect } from 'react'
import { Card, CardColors, Text, Pill, Loader, Link } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import {
  fetchAdminBankingProfile,
  selectAdminBankingProfile,
} from './adminBankingProfileSlice'
import { humanizeStatus, statusColor } from '@/features/banking/banking.helpers'

export const BankingProfilePanel = ({ userId }: { userId: number }) => {
  const dispatch = useAppDispatch()
  const profile = useReselector(selectAdminBankingProfile, userId)

  useEffect(() => {
    dispatch(fetchAdminBankingProfile(userId))
  }, [dispatch, userId])

  return (
    <Card color={CardColors.LEVEL_0} className="w-full">
      <div className="space-y-4">
        <Text variant={TypographyStyles.H1}>Heard Banking Profile</Text>

        {profile === undefined && <Loader inline size={16} />}

        {profile === null && (
          <Text variant={TypographyStyles.BODY_SM}>No banking profile</Text>
        )}

        {profile && (
          <>
            <div>
              <Text variant={TypographyStyles.EYEBROW}>Application Status</Text>
              <Pill color={statusColor(profile.applicationStatus)}>
                {humanizeStatus(profile.applicationStatus)}
              </Pill>
            </div>

            <div>
              <Text variant={TypographyStyles.EYEBROW}>Unit Customer ID</Text>
              <Text variant={TypographyStyles.BODY_SM}>
                {profile.providerUserId ?? '—'}
              </Text>
            </div>

            {profile.unitConsoleUrl && (
              <Link href={profile.unitConsoleUrl} newPage>
                Open in Unit console
              </Link>
            )}
          </>
        )}
      </div>
    </Card>
  )
}
